import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MEMBERCARD: AppRouteRecordRaw = {
  path: '/memberCard',
  name: 'memberCard',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.memberCard',
    icon: 'icon-user-group',
    requiresAuth: true,
    order: 8,
  },
  children: [
    {
      path: '/card',
      name: '/card',
      component: () => import('@/views/memberCard/index.vue'),
      meta: {
        locale: 'menu.memberCard.index',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default MEMBERCARD;
